// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container input[data-v-fedc9984]{position:absolute;opacity:0;cursor:pointer}.checkmark[data-v-fedc9984]:after{content:\"\";position:absolute;display:none}.container[data-v-fedc9984]{display:block;position:relative;padding-left:45.5px;cursor:pointer;font-size:22px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
